import * as React from 'react';
// import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux';
import Base from './base';
import String from './string';

class Name extends Base {
    constructor(props) {
        super(props);
        this.groupName = "Name";
        this.firstNameIdentifier = 'firstname';
        this.middleNameIdentifier = 'middlename';
        this.lastNameIdentifier = 'lastname';
    }

    renderOnCard() {
        const firstName = this.parseCustomFileds(this.props.data, this.firstNameIdentifier, this.groupName);
        const lastName = this.parseCustomFileds(this.props.data, this.lastNameIdentifier, this.groupName);

        let title;
        if (firstName[0].Value && lastName[0].Value) {
            title = `${firstName[0].Value}, ${lastName[0].Value}`
        } else if (firstName[0].Value && !lastName[0].Value) {
            title = `${firstName[0].Value}`
        } else if (!firstName[0].Value && lastName[0].Value) {
            title = `${lastName[0].Value}`
        }

        return (
            <span title={title} className="wkName">
                {firstName[0].Value && lastName[0].Value && <>
                    <String {...this.props} showLabel={false} returnValueForBlank={""}
                        data={lastName}
                    />,&nbsp;
                    <String {...this.props} showLabel={false} returnValueForBlank={""}
                        data={firstName}
                    />
                </>}
                {firstName[0].Value && !lastName[0].Value &&
                    <String {...this.props} showLabel={false} returnValueForBlank={""}
                        data={firstName}
                    />
                }
                {!firstName[0].Value && lastName[0].Value &&
                    <String {...this.props} showLabel={false} returnValueForBlank={""}
                        data={lastName}
                    />
                }
            </span>
        )
    }

    renderOnGrid() {
        const firstName = this.parseCustomFileds(this.props.data, this.firstNameIdentifier, this.groupName);
        const lastName = this.parseCustomFileds(this.props.data, this.lastNameIdentifier, this.groupName);
        return (
            <React.Fragment>
                {
                    firstName[0].Value && lastName[0].Value &&
                    <>
                        <String {...this.props} showLabel={false} returnValueForBlank={""}
                            data={lastName}
                        />
                        <String {...this.props} showLabel={false} includeSpace={true} returnValueForBlank={""} preAppendComma={true}
                            data={firstName}
                        />
                    </>
                }
                {
                    firstName[0].Value && !lastName[0].Value &&
                    <>
                        <String {...this.props} showLabel={false} returnValueForBlank={""}
                            data={firstName}
                        />
                    </>
                }
                {
                    !firstName[0].Value && lastName[0].Value &&
                    <>
                        <String {...this.props} showLabel={false} includeSpace={true} returnValueForBlank={""}
                            data={lastName}
                        />
                    </>
                }

            </React.Fragment>
        )
    }

    renderOnDetail() {
            return (
                <React.Fragment>
                    <String {...this.props} showLabel={false} includeSpace={true} returnValueForBlank={""}
                        data={this.parseCustomFileds(this.props.data, this.firstNameIdentifier, this.groupName)}
                    />
                    <String {...this.props} showLabel={false} includeSpace={true} returnValueForBlank={""}
                        data={this.parseCustomFileds(this.props.data, this.middleNameIdentifier, this.groupName)}
                    />
                    <String {...this.props} showLabel={false} returnValueForBlank={""}
                        data={this.parseCustomFileds(this.props.data, this.lastNameIdentifier, this.groupName)}
                    />
                </React.Fragment>
            )
    }

    renderOnCreate() {
        return (
            <div>need to insert template</div>
        )
    }
}

export default Name;